<template>
    <div class="pt-12">
        <h2>{{advert.title}}</h2>
        <h4 class="mb-4">{{advert.price}}</h4>
        <p class="mb-8">{{advert.description}}</p>
        <div class="d-flex flex-wrap img-container">
        <div class="d-flex img-item">
            <img src="/images/annonces1.png" alt="" />
        </div>
        <div class="d-flex img-item">
            <img src="/images/annonces2.png" alt="" />
        </div>
        <div class="d-flex img-item">
            <img src="/images/annonces3.png" alt="" />
        </div>
        <div class="d-flex img-item">
            <img src="/images/annonces4.png" alt="" />
        </div>
        </div>
        <div class="d-flex justify-center mt-12">
        <v-btn class="mt-4 mx-4 primary-button">Accepter</v-btn>
        <v-btn class="mt-4 mx-4 primary-button outlined">Refuser</v-btn>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'AnnonceDetail',
    props: ['advertId'],
    data: () => {
      return {
        advert: {
            title: '',
            description: '',
            price: '',
            images: []
        }
      }
    },
    async created () {
      try {
        // ADVERT
        const advertRes = await axios.get(`${apiURL}/neighborhood/ad/${this.advertId}`)
        this.advert = advertRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>